import { ComponentType } from "react";
import { SvgIconComponent } from "@mui/icons-material";
import LocationCityIcon from "@mui/icons-material/LocationCity";
import PublicIcon from "@mui/icons-material/Public";
import PsychologyIcon from "@mui/icons-material/Psychology";
import ViewCarouselIcon from "@mui/icons-material/ViewCarousel";
import EventIcon from "@mui/icons-material/Event";
import GroupIcon from "@mui/icons-material/Group";
import PersonIcon from "@mui/icons-material/Person";
import SubscriptionsIcon from "@mui/icons-material/Subscriptions";
import FeedIcon from "@mui/icons-material/Feed";
import LocalActivityIcon from "@mui/icons-material/LocalActivity";
import SurfingIcon from "@mui/icons-material/Surfing";
import QuestionAnswerIcon from "@mui/icons-material/QuestionAnswer";
import HubIcon from "@mui/icons-material/Hub";
import CardGiftcardIcon from "@mui/icons-material/CardGiftcard";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import GroupsIcon from "@mui/icons-material/Groups";
import HowToRegIcon from "@mui/icons-material/HowToReg";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";

import {
  CitiesManagement,
  CompetenciesManagement,
  CountriesManagement,
  BannersManagement,
  FieldActivitiesManagement,
  HobbiesManagement,
  JoiningApplicationsManagement,
  NewsManagement,
  EventsManagement,
  ResidentsManagement,
  CommunityUsersManagement,
  SubscriptionPlansManagement,
  RaplRequestsManagement,
  ConnectManagement,
  BenefitsManagement,
  InvestmentsManagement,
  ClubsManagement,
} from "../../admin";
import {
  ADMIN_PERMISSION_BANNERS,
  ADMIN_PERMISSION_HOBBIES,
  ADMIN_PERMISSION_FIELD_ACTIVITIES,
  ADMIN_PERMISSION_COUNTRIES,
  ADMIN_PERMISSION_COMPETENCIES,
  ADMIN_PERMISSION_CITIES,
  ADMIN_PERMISSION_JOIN_REQUESTS,
  ADMIN_PERMISSION_NEWS,
  ADMIN_PERMISSION_EVENTS,
  ADMIN_PERMISSION_COMMUNITIES,
  ADMIN_PERMISSION_SUBSCRIPTION_PLANS,
  ADMIN_PERMISSION_RAPL_REQUESTS,
  ADMIN_PERMISSION_RAPL_CONNECT,
  ADMIN_PERMISSION_BENEFITS,
  ADMIN_PERMISSION_INVESTMENTS,
  ADMIN_PERMISSION_CLUBS,
  ADMIN_PERMISSION_USER_PERMISSIONS,
} from "../../../shared/constants/admin-permission-ids";
import { ROUTER_PATHS } from "../../../shared/constants";

export type AdminContentType =
  | "cities"
  | "countries"
  | "competencies"
  | "banners"
  | "field-activities"
  | "hobbies"
  | "join-requests"
  | "news"
  | "events"
  | "residents"
  | "community-users"
  | "subscription-plans"
  | "rapl-requests"
  | "connect"
  | "benefits"
  | "investments"
  | "clubs";

export type AdminNavKey = AdminContentType | "permissions";

export interface AdminMenuItem {
  id: number;
  key: AdminContentType;
  label: string;
  icon: SvgIconComponent;
  component: ComponentType;
}

export interface AdminNavItem {
  key: AdminNavKey;
  label: string;
  icon: SvgIconComponent;
  path: string;
  permissionId: number;
}

export interface AdminNavGroup {
  id: string;
  label: string;
  keys: AdminNavKey[];
}

export const ADMIN_MENU_ITEMS: AdminMenuItem[] = [
  {
    id: ADMIN_PERMISSION_CITIES,
    key: "cities",
    label: "Города",
    icon: LocationCityIcon,
    component: CitiesManagement,
  },
  {
    id: ADMIN_PERMISSION_COUNTRIES,
    key: "countries",
    label: "Страны",
    icon: PublicIcon,
    component: CountriesManagement,
  },
  {
    id: ADMIN_PERMISSION_COMPETENCIES,
    key: "competencies",
    label: "Компетенции",
    icon: PsychologyIcon,
    component: CompetenciesManagement,
  },
  {
    id: ADMIN_PERMISSION_BANNERS,
    key: "banners",
    label: "Баннеры",
    icon: ViewCarouselIcon,
    component: BannersManagement,
  },
  {
    id: ADMIN_PERMISSION_FIELD_ACTIVITIES,
    key: "field-activities",
    label: "Сферы деятельности",
    icon: LocalActivityIcon,
    component: FieldActivitiesManagement,
  },
  {
    id: ADMIN_PERMISSION_HOBBIES,
    key: "hobbies",
    label: "Хобби",
    icon: SurfingIcon,
    component: HobbiesManagement,
  },
  {
    id: ADMIN_PERMISSION_JOIN_REQUESTS,
    key: "join-requests",
    label: "Запросы на вступление",
    icon: HowToRegIcon,
    component: JoiningApplicationsManagement,
  },
  {
    id: ADMIN_PERMISSION_NEWS,
    key: "news",
    label: "Новости",
    icon: FeedIcon,
    component: NewsManagement,
  },
  {
    id: ADMIN_PERMISSION_EVENTS,
    key: "events",
    label: "Мероприятия",
    icon: EventIcon,
    component: EventsManagement,
  },
  {
    id: ADMIN_PERMISSION_COMMUNITIES,
    key: "residents",
    label: "Резиденты",
    icon: PersonIcon,
    component: ResidentsManagement,
  },
  {
    id: ADMIN_PERMISSION_COMMUNITIES,
    key: "community-users",
    label: "Пользователи сообщества",
    icon: GroupIcon,
    component: CommunityUsersManagement,
  },
  {
    id: ADMIN_PERMISSION_SUBSCRIPTION_PLANS,
    key: "subscription-plans",
    label: "Подписки",
    icon: SubscriptionsIcon,
    component: SubscriptionPlansManagement,
  },
  {
    id: ADMIN_PERMISSION_RAPL_REQUESTS,
    key: "rapl-requests",
    label: "RAPL запросы",
    icon: QuestionAnswerIcon,
    component: RaplRequestsManagement,
  },
  {
    id: ADMIN_PERMISSION_RAPL_CONNECT,
    key: "connect",
    label: "RAPL Connect",
    icon: HubIcon,
    component: ConnectManagement,
  },
  {
    id: ADMIN_PERMISSION_BENEFITS,
    key: "benefits",
    label: "RAPL Benefits",
    icon: CardGiftcardIcon,
    component: BenefitsManagement,
  },
  {
    id: ADMIN_PERMISSION_INVESTMENTS,
    key: "investments",
    label: "Инвестиции",
    icon: TrendingUpIcon,
    component: InvestmentsManagement,
  },
  {
    id: ADMIN_PERMISSION_CLUBS,
    key: "clubs",
    label: "Клубы коллаборации",
    icon: GroupsIcon,
    component: ClubsManagement,
  },
];

export const PERMISSIONS_NAV_ITEM: AdminNavItem = {
  key: "permissions",
  label: "Права доступа",
  icon: AdminPanelSettingsIcon,
  path: `/${ROUTER_PATHS.PERMISSIONS}`,
  permissionId: ADMIN_PERMISSION_USER_PERMISSIONS,
};

export const ADMIN_NAV_GROUPS: AdminNavGroup[] = [
  {
    id: "community",
    label: "Сообщество",
    keys: ["community-users", "residents", "join-requests", "clubs"],
  },
  {
    id: "content",
    label: "Контент",
    keys: ["news", "events", "banners"],
  },
  {
    id: "products",
    label: "Продукты",
    keys: [
      "connect",
      "benefits",
      "investments",
      "rapl-requests",
      "subscription-plans",
    ],
  },
  {
    id: "catalogs",
    label: "Справочники",
    keys: [
      "cities",
      "countries",
      "competencies",
      "hobbies",
      "field-activities",
    ],
  },
  {
    id: "system",
    label: "Система",
    keys: ["permissions"],
  },
];

const toNavItem = (item: AdminMenuItem): AdminNavItem => ({
  key: item.key,
  label: item.label,
  icon: item.icon,
  path: `/${item.key}`,
  permissionId: item.id,
});

export const getNavItemByKey = (key: AdminNavKey): AdminNavItem | undefined => {
  if (key === "permissions") {
    return PERMISSIONS_NAV_ITEM;
  }
  const item = ADMIN_MENU_ITEMS.find((i) => i.key === key);
  return item ? toNavItem(item) : undefined;
};

export const isAdminContentType = (value: string): value is AdminContentType =>
  ADMIN_MENU_ITEMS.some((item) => item.key === value);

export const getAvailableMenuItems = (
  permissions: number[],
): AdminMenuItem[] => {
  return ADMIN_MENU_ITEMS.filter((item) => permissions.includes(item.id));
};

export const hasAdminMenuAccess = (
  permissions: number[],
  key: AdminContentType,
): boolean => {
  const item = ADMIN_MENU_ITEMS.find((i) => i.key === key);
  return item ? permissions.includes(item.id) : false;
};

export const getAvailableNavGroups = (
  permissions: number[],
): Array<AdminNavGroup & { items: AdminNavItem[] }> => {
  return ADMIN_NAV_GROUPS.map((group) => ({
    ...group,
    items: group.keys
      .map((key) => getNavItemByKey(key))
      .filter((item): item is AdminNavItem =>
        Boolean(item && permissions.includes(item.permissionId)),
      ),
  })).filter((group) => group.items.length > 0);
};

export const getDefaultNavItem = (
  permissions: number[],
): AdminNavItem | undefined => {
  for (const group of getAvailableNavGroups(permissions)) {
    if (group.items[0]) {
      return group.items[0];
    }
  }
  return undefined;
};

export const getDefaultMenuItem = (
  permissions: number[],
): AdminMenuItem | undefined => {
  const defaultNav = getDefaultNavItem(permissions);
  if (!defaultNav || defaultNav.key === "permissions") {
    return getAvailableMenuItems(permissions)[0];
  }
  return ADMIN_MENU_ITEMS.find((item) => item.key === defaultNav.key);
};

export const getNavItemByPath = (pathname: string): AdminNavItem | undefined => {
  const normalized = pathname.replace(/\/$/, "") || "/";
  if (normalized === `/${ROUTER_PATHS.PERMISSIONS}`) {
    return PERMISSIONS_NAV_ITEM;
  }
  const key = normalized.slice(1);
  if (isAdminContentType(key)) {
    return getNavItemByKey(key);
  }
  return undefined;
};
